import { Flex, Modal, Text } from "@mantine/core";

import SvgWarning from "../../../components/Icons/Warning";

interface ErrorKYCModalProps {
  opened: boolean;
  onClose: () => void;
  reason?: string;
}

const ErrorKYCModal = ({ opened, onClose, reason }: ErrorKYCModalProps) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      size="sm"
      withCloseButton={true}
      closeOnClickOutside={true}
      closeOnEscape={true}
      radius="lg"
      padding="xl"
    >
      <Flex direction="column" align="center" gap={36} pb={24}>
        <SvgWarning width={80} height={80} color="#FF6B6B" />
        <Text align="center" color="dimmed">
          KYC process has failed.
        </Text>
        {reason && (
          <Text align="center" color="red" size="sm">
            Reason: {reason}
          </Text>
        )}
      </Flex>
    </Modal>
  );
};

export default ErrorKYCModal;
